import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface SidebarState {
  isCollapsed: boolean
  isMobile: boolean
  setIsCollapsed: (collapsed: boolean) => void
  setIsMobile: (mobile: boolean) => void
  toggleCollapsed: () => void
}

export const useSidebarStore = create<SidebarState>()(
  persist(
    set => ({
      isCollapsed: false,
      isMobile: false,
      setIsCollapsed: collapsed => set({ isCollapsed: collapsed }),
      setIsMobile: mobile => set({ isMobile: mobile }),
      toggleCollapsed: () => set(state => ({ isCollapsed: !state.isCollapsed })),
    }),
    {
      name: 'sidebar-storage',
      partialize: state => ({ isCollapsed: state.isCollapsed }),
    }
  )
)
